import PropTypes from "prop-types";
import React, { useState } from "react";
import { connect } from "react-redux";
import axios from "axios";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  CircularProgress,
} from "@mui/material";
import { Alert } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { validateEmail } from "../../utils/utilityFunctions";

const useStyles = makeStyles()((theme) => ({
  progress: {
    position: "absolute",
  },
}));

export const GiftAFriendViaEmail = (props) => {
  const { classes } = useStyles();

  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isSendingEmail, setIsSendingEmail] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setEmail("");
    setError("");
    setSuccessMessage("");
  };

  const handleSend = () => {
    if (validateEmail(email)) {
      console.log(`Sending email to: ${email}`);

      setIsSendingEmail(true);

      axios
        .post("/api/referrals/sendReferralInvite", {
          email,
          referralCode: props.referralCode,
        })
        .then((res) => {
          console.log("Email sent successfully:", res.data);
          setError("");
          setSuccessMessage("Gift sent successfully!");
          setIsSendingEmail(false);
          setTimeout(() => {
            handleClose();
          }, 1000);
        })
        .catch((err) => {
          console.error("Error sending email:", err);
          setError("Failed to send email. Please try again.");
          setIsSendingEmail(false);
        });
    } else {
      setError("Please enter a valid email address.");
    }
  };

  // Use referralLoading from props
  const isButtonLoading =
    isSendingEmail || props.user.loading || props.referralLoading;
  const isButtonDisabled =
    isButtonLoading || !props.user.credentials.referralCode || props.disabled;

  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        onClick={handleOpen}
        fullWidth
        disabled={isButtonDisabled}
        style={{ position: "relative" }}
      >
        Send gift via email
        {isButtonLoading && (
          <CircularProgress size={25} className={classes.progress} />
        )}
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Gift 1 Month via Email</DialogTitle>
        <DialogContent>
          <TextField
            variant="standard"
            autoFocus
            margin="dense"
            label="Email Address"
            type="email"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            error={!!error}
            helperText={error}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSend();
              }
            }}
          />
          {successMessage && (
            <Alert severity="success" style={{ marginTop: "1rem" }}>
              {successMessage}
            </Alert>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            variant="outlined"
            color="secondary"
            disabled={isSendingEmail || props.referralLoading}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSend}
            variant="contained"
            color="primary"
            disabled={
              isSendingEmail ||
              props.user.loading ||
              !props.user.credentials.referralCode ||
              props.referralLoading
            }
            style={{ position: "relative" }}
          >
            Send gift
            {(isSendingEmail || props.referralLoading) && (
              <CircularProgress size={25} className={classes.progress} />
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

GiftAFriendViaEmail.propTypes = {
  referralLoading: PropTypes.bool,
  disabled: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  referralCode: state.user.credentials.referralCode,
  user: state.user,
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GiftAFriendViaEmail);
